import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreatePromptAnalysisRequest, PromptAnalysis } from '@brand24-original/llm-types';
import { createPromptAnalysis } from '../../services/prompt-analysis/PromptAnalysisService';
import { GET_PROMPT_ANALYSES, GET_PROMPT_ANALYSIS_USAGE } from '../../query/prompt-analysis/keys';

export const useCreatePromptAnalysis = (
  projectId: number,
  options?: { onSuccess?: (analysis: PromptAnalysis) => void }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CreatePromptAnalysisRequest) => createPromptAnalysis(projectId, body),
    onSuccess: (analysis) => {
      void queryClient.invalidateQueries({ queryKey: [GET_PROMPT_ANALYSES, projectId] });
      // A new review consumes a quota slot right away (PENDING already counts).
      void queryClient.invalidateQueries({ queryKey: [GET_PROMPT_ANALYSIS_USAGE] });
      options?.onSuccess?.(analysis);
    },
  });
};
